document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('stitch-consultation-form')) return;
  event.preventDefault();
  if (!form.reportValidity()) return;

  const base = form.dataset.whatsappUrl;
  if (!base) {
    window.alert('WhatsApp is not configured. Please contact Sabaayat Styles directly.');
    return;
  }

  const fields = [
    ['Full Name', 'contact[name]'],
    ['Phone / WhatsApp Number', 'contact[phone]'],
    ['Email Address', 'contact[email]'],
    ['Design / Product Name or Reference', 'contact[Design reference]'],
    ['Required Size / Custom Measurements', 'contact[Measurements]'],
    ['Preferred Fit', 'contact[Preferred fit]'],
    ['Required Date', 'contact[Required date]'],
    ['Delivery / Collection Preference', 'contact[Delivery preference]'],
    ['Stitching Notes / Special Requests', 'contact[Special requests]'],
    ['Additional Notes', 'contact[body]']
  ];
  const lines = ['Hello Sabaayat Styles, I would like to book a custom stitching consultation.', ''];
  fields.forEach(function (field) {
    const input = form.elements.namedItem(field[1]);
    const value = input && 'value' in input ? input.value.trim() : '';
    if (value) lines.push(field[0] + ': ' + value);
  });
  try {
    const url = new URL(base);
    if (url.protocol !== 'https:' || url.hostname !== 'wa.me') throw new Error('Invalid WhatsApp link');
    url.searchParams.set('text', lines.join('\n'));
    const chat = window.open(url.toString(), '_blank');
    if (chat) {
      chat.opener = null;
      const thanks = form.querySelector('.stitch-thank-you');
      if (thanks) {
        thanks.hidden = false;
        thanks.focus();
      }
    } else {
      window.location.assign(url.toString());
    }
  } catch (error) {
    window.alert('WhatsApp link is unavailable. Please contact Sabaayat Styles directly.');
  }
}, true);
